import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FaRobot, FaRocket, FaUsers, FaPlay, FaCode, FaChartLine, FaBolt } from 'react-icons/fa';
import './BootcampHero.css';

const BootcampHero = ({
  nextSessionDate,
  showRegistration = true,
  onRegisterClick
}) => {
  const handleRegisterClick = () => {
    if (onRegisterClick) {
      onRegisterClick();
    } else {
      window.location.href = '/ai-bot-builder-bootcamp';
    }
  };

  // Key benefits - scannable bullet points
  const keyBenefits = [
    { icon: <FaCode />, text: 'No coding required' },
    { icon: <FaChartLine />, text: 'Build workflows for stocks, crypto, options, and futures' },
    { icon: <FaBolt />, text: 'Test and launch inside BotSpot' },
    { icon: <FaPlay />, text: 'Lifetime access to recordings' }
  ];

  return (
    <div className="bootcamp-hero">
      <Container>
        <Row className="justify-content-center">
          <Col lg={10} xl={9}>
            <div className="bootcamp-hero-content">
              <div className="bootcamp-hero-badge">
                <FaRobot className="me-2" />
                AI-Powered Trading Education
              </div>

              <h1 className="bootcamp-hero-title">
                AI Bootcamp
              </h1>

              <h2 className="bootcamp-hero-subtitle">
                5 Weeks to Your Own AI Investing Workflow
              </h2>

              {/* Transformation Image - Visual before/after story */}
              <div className="bootcamp-hero-transformation">
                <picture>
                  <source
                    srcSet="/images/bootcamp-transformation-1000.webp"
                    type="image/webp"
                  />
                  <img
                    src="/images/bootcamp-transformation-1000.jpg"
                    alt="Move from manual investing ideas to an AI-assisted BotSpot workflow in 5 weeks"
                    className="bootcamp-hero-transformation-image"
                    loading="lazy"
                    decoding="async"
                    width="1000"
                    height="545"
                  />
                </picture>
              </div>

              {/* Scannable Benefits List */}
              <div className="bootcamp-hero-benefits">
                {keyBenefits.map((benefit, index) => (
                  <div key={index} className="bootcamp-hero-benefit-item">
                    <span className="benefit-icon">{benefit.icon}</span>
                    <span className="benefit-text">{benefit.text}</span>
                  </div>
                ))}
              </div>

              {showRegistration && (
                <div className="bootcamp-hero-cta">
                  <Button
                    size="lg"
                    className="bootcamp-hero-register-btn"
                    onClick={handleRegisterClick}
                  >
                    <FaRocket className="me-2" />
                    Join the Next Bootcamp
                  </Button>

                  <div className="bootcamp-hero-cta-subtext">
                    <FaUsers className="me-1" />
                    Limited spots available
                  </div>
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BootcampHero;
